export default function WpctFbModal(triggers) {
  this.layer = document.getElementById("wpct-fb-dialog-layer");
  if (!this.layer) {
    this.layer = document.createElement("div");
    this.layer.id = "wpct-fb-dialog-layer";
    this.layer.setAttribute("aria-live", "polite");
    document.body.appendChild(this.layer);
  }

  this.layer.addEventListener("click", this.onClickOut);

  document.addEventListener("keydown", (ev) => {
    if (ev.key === "Escape") {
      if (this.layer.children.length) {
        this.onClickOut(ev, true);
      }
    }
  });

  for (let trigger of triggers) {
    let anchor;
    if (trigger.href) {
      anchor = trigger;
    } else {
      anchor = trigger.querySelector("a");
    }

    if (!anchor) {
      continue;
    }

    anchor.addEventListener("click", (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      this.show(trigger.dataset.dialogTitle, anchor.href);
    });
  }
}

WpctFbModal.prototype.show = function (title, href) {
  const dialog = this.open(title);
  fetch(href)
    .then((res) => res.text())
    .then((html) => this.render(html, dialog));
};

WpctFbModal.prototype.open = function (title) {
  const dialog = this.getDialog(title);
  this.layer.innerHTML = "";
  this.layer.appendChild(dialog);
  this.layer.classList.add("is-open");
  document.body.classList.add("is-wpct-fb-modal-open");
  return dialog;
};

WpctFbModal.prototype.render = function (html, dialog) {
  const template = document.createElement("template");
  template.innerHTML = html;

  dialog.innerHTML = "";
  const header = document.createElement("header");
  header.innerHTML = `<h2 id="wpct-fb-dialog-title" class="wp-block-heading" style="margin-bottom:0">${dialog.dataset.title}</h2><button>✕</button>`;
  dialog.appendChild(header);

  header
    .querySelector("button")
    .addEventListener("click", (ev) => this.onClickOut(ev, true));

  const wrapper = document.createElement("main");
  dialog.appendChild(wrapper);

  for (let child of template.content.querySelector(".site-content").children) {
    wrapper.appendChild(child);
  }
};

WpctFbModal.prototype.getDialog = function (title) {
  const dialog = document.createElement("div");
  dialog.classList.add("wpct-fb-dialog");
  dialog.role = "dialog";
  dialog.setAttribute("aria-modal", "true");
  dialog.setAttribute("aria-labelledby", "wpct-fb-dialog-title");

  dialog.innerHTML = `<div class="wpct-fb-dialog-spinner" aria-hidden="true"></div>`;
  dialog.dataset.title = title;
  return dialog;
};

WpctFbModal.prototype.onClickOut = function (ev, force) {
  ev.preventDefault();
  ev.stopPropagation();

  const layer = document.getElementById("wpct-fb-dialog-layer");
  if (!layer) return;

  if (layer.children.length === 0) return;

  if (!force) {
    if (layer.children[0].contains(ev.target)) {
      return;
    }
  }

  layer.innerHTML = "";
  layer.classList.remove("is-open");
  document.body.classList.remove("is-wpct-fb-modal-open");
};

WpctFbModal.mount = function () {
  const triggers = document.querySelectorAll(".wpct-fb-modal__trigger");
  if (triggers.length === 0) return;
  return new WpctFbModal(triggers);
};
